import { type DocNode } from '@atlaskit/adf-schema';
import { Node as PMNode, type Schema } from '@atlaskit/editor-prosemirror/model';
import { convertProsemirrorNodeToMarkdown } from '@atlassian/ai-model-io/convert-prosemirror-to-markdown';

export const parseAdfToMarkdown = (adf: DocNode, schema: Schema): string => {
	const prosemirrorNode = PMNode.fromJSON(schema, adf);
	return convertProsemirrorNodeToMarkdown({ node: prosemirrorNode }).markdown;
};
